module.exports = __webpack_public_path__ + "img/icon10.f62078af.png";